define('views/modules/calendar/personal-data/manager/edit/personal-data-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parents views
    'src/views/form-view',
    // views
    'views/parts/menu/menu-save-action',
    'views/modules/calendar/personal-data/manager/form/personal-data-form',
    'views/parts/alert/alert-list',
    // templates
    'text!templates/modules/calendar/personal-data/manager/edit/personal-data-edit-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // parent views
    VForm,
    // views
    VMenuSaveAction,
    VPersonalDataForm,
    VAlertList,
    // templates
    TPersonalDataEditContent
) {

    var VPersonalDataEditContent = VForm.extend({

        template: TPersonalDataEditContent,

        regions: {
            root: ".personal-data-edit-content",
            menu: ".menu-actions",
            form: ".personal-data-edit-form",
            alert: ".personal-data-alert"
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.group = this.model.get("group");

            var view = this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSave,
                    saveText: "Save",
                    tooltip: {
                        container: this.regions.root,
                    }
                }),
                form: new VPersonalDataForm({
                    model: this.model,
                }),
                alert: new VAlertList()
            };

            this.listenTo(this.model, { 'change': this.onModelChange });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.setPristine();

            this.assign(view.menu, zone.$menu)
                .assign(view.form, zone.$form)
                .assign(view.alert, zone.$alert);

            this.view.alert.reset();

        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onSave: function() {
            if (this.model.get('unit') === "") {
                this.view.alert.reset();
                this.view.alert.addError('please-select-a-unit');
            } else {
                this.submit();
            }
        },

        onSuccess: function() {
            this.trigger('form:success', this.model.clone());
        },
    });

    return VPersonalDataEditContent;

});

